export const SET_USER_TYPE = "SET_USER_TYPE";
export const SET_USER = "SET_USER";
export const SET_AUTH = "SET_AUTH";
export const SET_LOGIN_STATUS = "SET_LOGIN_STATUS";
export const UPDATE_USER = "UPDATE_USER";
